export const DocumentSlashSeparator: React.FC<
  React.HTMLAttributes<HTMLSpanElement>
> = ({ style, ...rest }) => (
  <span {...rest} style={{ fontWeight: 200, ...style }}>
    {' '}
    /{' '}
  </span>
);
